import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Breadcrumb,
  Checkbox,
  Collapse,
  Form,
  Input,
  Spin,
  Table,
  Tooltip,
} from "antd";
import { useTranslation } from "react-i18next";
import { confirmAlert } from "react-confirm-alert";
import ButtonField from "../../../common/htmlComponents/ButtonField";
import { ReactComponent as RupeesSign } from "../../../image/RupeesSign.svg";
import { authUserData } from "../../../utils/Helper";
import { SuccessNotificationMsg } from "../../../utils/Notifications";

const { Panel } = Collapse;

const STATIC_RFQ_RESPONSE = {
  success: true,
  data: {
    id: 578,
    company_id: 39,
    company: "Rapid infra",
    rfq_number: "00057",
    category_tree_name: "Sand",
    sand_conversion: 1.6,
    aggregate_conversion: 1.45,
    rfq_vendor_assign_sales_id: 812,
    vendor_id: 55,
    vendor_name: "Vendor Two Procem",
    bid_rfq_by_vendor: true,
    is_final_bid_price: true,
    final_bid_data: false,
    currency: 1,
    currency_name: "Rupee",
    price_basis: "Firm",
    freight: "Seller's Scope",
    unloading: "Buyer's Scope",
    transport_insurance: "Seller's Scope",
    open_order: false,
    amount_cap: null,
    delivery_date: "02-03-26",
    delivery_start_date: null,
    delivery_end_date: null,
    rfq_due_date: "25-02-26 16:00",
    buying_pattern: "Unit Rate of Cement excluding Freight",
    bid_buying_pattern: "Unit Rate of Cement excluding Freight",
    is_diameter_wise: false,
    bid_rfq_material_wise_detail: [
      {
        rfq_material_detail: [3089],
        material_type_name: "Crushed Sand",
        material_type: 8299,
        material_type_sub_category: "IS: 2116",
        material_total_quantity: 1,
        material_total_quantity_by_kg: 1000,
        gst_rate: 5,
        gst_rate_freight: 0,
        unit_of_measurement: 32,
        material_wise_uom: "MT",
        id: 2742,
        bid_rfq_id: 2742,
        unit_rate_with_gst: 451.5,
        amount: 50000,
        initial_bid_price_unit_rate: 430,
        initial_bid_price_unit_rate_of_freight: 0,
        initial_bid_price_date: null,
        initial_bid_amount_with_gst: 451.5,
        initial_bid_amount_without_gst: 430,
        is_initial_bid: false,
        revised_bid_price_unit_rate: 0,
        revised_bid_price_unit_rate_of_freight: 0,
        revised_bid_price_date: null,
        revised_bid_amount_with_gst: 0,
        revised_bid_amount_without_gst: 0,
        is_revised_bid: false,
        final_bid_price_unit_rate: 0,
        final_bid_price_unit_rate_of_freight: 0,
        final_bid_price_date: null,
        final_bid_amount_with_gst: 0,
        final_bid_amount_without_gst: 0,
        is_final_bid: false,
      },
      {
        rfq_material_detail: [3090],
        material_type_name: "River Sand",
        material_type: 8300,
        material_type_sub_category: "IS: 2116",
        material_total_quantity: 2,
        material_total_quantity_by_kg: 2000,
        gst_rate: 5,
        gst_rate_freight: 0,
        unit_of_measurement: 32,
        material_wise_uom: "MT",
        id: 2743,
        bid_rfq_id: 2743,
        unit_rate_with_gst: 450.45,
        amount: 100000,
        initial_bid_price_unit_rate: 0,
        initial_bid_price_unit_rate_of_freight: 0,
        initial_bid_price_date: null,
        is_initial_bid: false,
        revised_bid_price_unit_rate: 0,
        revised_bid_price_unit_rate_of_freight: 0,
        revised_bid_price_date: null,
        is_revised_bid: false,
        final_bid_price_unit_rate: 0,
        final_bid_price_unit_rate_of_freight: 0,
        final_bid_price_date: null,
        is_final_bid: false,
      },
      {
        rfq_material_detail: [3091],
        material_type_name: "Crushed Sand",
        material_type: 8129,
        material_type_sub_category: "IS: 2116",
        material_total_quantity: 2,
        material_total_quantity_by_kg: 2000,
        gst_rate: 5,
        gst_rate_freight: 0,
        unit_of_measurement: 32,
        material_wise_uom: "MT",
        id: 2744,
        bid_rfq_id: 2744,
        unit_rate_with_gst: 477.75,
        amount: 100000,
        initial_bid_price_unit_rate: 0,
        initial_bid_price_unit_rate_of_freight: 0,
        initial_bid_price_date: null,
        is_initial_bid: false,
        revised_bid_price_unit_rate: 0,
        revised_bid_price_unit_rate_of_freight: 0,
        revised_bid_price_date: null,
        is_revised_bid: false,
        final_bid_price_unit_rate: 0,
        final_bid_price_unit_rate_of_freight: 0,
        final_bid_price_date: null,
        is_final_bid: false,
      },
      {
        rfq_material_detail: [3092],
        material_type_name: "River Sand",
        material_type: 8130,
        material_type_sub_category: "IS: 2116",
        material_total_quantity: 1,
        material_total_quantity_by_kg: 1000,
        gst_rate: 5,
        gst_rate_freight: 0,
        unit_of_measurement: 32,
        material_wise_uom: "MT",
        id: 2745,
        bid_rfq_id: 2745,
        unit_rate_with_gst: 488.25,
        amount: 50000,
        initial_bid_price_unit_rate: 0,
        initial_bid_price_unit_rate_of_freight: 0,
        initial_bid_price_date: null,
        is_initial_bid: false,
        revised_bid_price_unit_rate: 0,
        revised_bid_price_unit_rate_of_freight: 0,
        revised_bid_price_date: null,
        is_revised_bid: false,
        final_bid_price_unit_rate: 0,
        final_bid_price_unit_rate_of_freight: 0,
        final_bid_price_date: null,
        is_final_bid: false,
      },
    ],
  },
};

const mapMaterialToTableRow = (material, index) => {
  const unitRate = material.initial_bid_price_unit_rate || 0;
  const freight = material.initial_bid_price_unit_rate_of_freight || 0;
  const qty = material.material_total_quantity || 0;

  return {
    key: `material-${material.bid_rfq_id || material.id || index}`,
    sr_no: index + 1,
    material_type_name: material.material_type_name || "",
    material_type_sub_category: material.material_type_sub_category || "",
    material_type: material.material_type,
    material_wise_uom: material.material_wise_uom || "MT",
    material_wise_uom_id: material.unit_of_measurement,
    material_total_quantity: qty,
    material_total_quantity_by_kg: material.material_total_quantity_by_kg || 0,
    gst_rate: material.gst_rate || 0,
    gst_rate_freight: material.gst_rate_freight || 0,
    initial_bid_price_unit_rate: unitRate,
    initial_bid_price_unit_rate_of_freight: freight,
    initial_bid_price_amount:
      (unitRate + freight) * qty || material.initial_bid_amount_without_gst || 0,
    revised_bid_price_unit_rate: material.revised_bid_price_unit_rate || 0,
    revised_bid_price_unit_rate_of_freight:
      material.revised_bid_price_unit_rate_of_freight || 0,
    revised_bid_price_amount:
      ((material.revised_bid_price_unit_rate || 0) +
        (material.revised_bid_price_unit_rate_of_freight || 0)) *
      qty,
    final_bid_price_unit_rate: material.final_bid_price_unit_rate || 0,
    final_bid_price_unit_rate_of_freight:
      material.final_bid_price_unit_rate_of_freight || 0,
    final_bid_price_amount:
      ((material.final_bid_price_unit_rate || 0) +
        (material.final_bid_price_unit_rate_of_freight || 0)) *
      qty,
    unit_rate_with_gst: material.unit_rate_with_gst || 0,
    unit_rate_with_gst_revised: material.revised_unit_rate_with_gst || 0,
    unit_rate_with_gst_final: material.final_unit_rate_with_gst || 0,
    initial_bid_price_date: material.initial_bid_price_date,
    revised_bid_price_date: material.revised_bid_price_date,
    final_bid_price_date: material.final_bid_price_date,
    rfq_material_detail: material.rfq_material_detail,
    bid_rfq_id: material.bid_rfq_id || material.id,
    is_initial_bid: material.is_initial_bid,
    is_revised_bid: material.is_revised_bid,
    is_final_bid: material.is_final_bid,
    aggregate_conversion: material.aggregate_conversion,
    sand_conversion: material.sand_conversion,
    category_tree_name: material.category_tree_name,
  };
};

const buildGrandTotalRow = (rows) => {
  const materialRows = rows.filter((r) => r.material_type_name && !r.isGrandTotal);

  const sumAmount = (fieldUnit, fieldFreight) =>
    materialRows.reduce(
      (acc, r) =>
        acc +
        ((r[fieldUnit] || 0) + (r[fieldFreight] || 0)) *
          (r.material_total_quantity || 0),
      0
    );

  return {
    key: "grand-total",
    isGrandTotal: true,
    rowLabel: "Grand Total",
    total_initial_bid_price_unit_rate: sumAmount(
      "initial_bid_price_unit_rate",
      "initial_bid_price_unit_rate_of_freight"
    ),
    total_revised_bid_price_unit_rate: sumAmount(
      "revised_bid_price_unit_rate",
      "revised_bid_price_unit_rate_of_freight"
    ),
    total_final_bid_price_unit_rate: sumAmount(
      "final_bid_price_unit_rate",
      "final_bid_price_unit_rate_of_freight"
    ),
  };
};

const calculateUnitRateWithGst = (
  unitRate,
  freightRate,
  gstRate,
  gstRateFreight
) => {
  const gstAmount = unitRate + unitRate * (gstRate / 100);
  const gstAmountWithFreight =
    (freightRate || 0) + (freightRate || 0) * ((gstRateFreight || 0) / 100);
  return gstAmount + gstAmountWithFreight;
};

const VendorBidGeneralRFQ = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const formRef = useRef();
  const vendorBidId = id ? atob(id) : null;
  const VendorId = authUserData()?.vendor ? authUserData()?.vendor : null;

  const [apiLoading, setApiLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rfqDetails, setRfqDetails] = useState({});
  const [rfqData, setRfqData] = useState({ open_order: false });
  const [tableData, setTableData] = useState([]);
  const [currentStep, setCurrentStep] = useState(0);
  const [isFinalBid, setIsFinalBid] = useState(false);
  const [hideR0, setHideR0] = useState(false);
  const [hideR1, setHideR1] = useState(false);
  const [buyingPatternPayload, setBuyingPatternPayload] = useState(null);
  const [showUnitRateOfCement, setShowUnitRateOfCement] = useState(true);
  const [showUnitRateOfFreight, setShowUnitRateOfFreight] = useState(true);

  const [initialBidDates, setInitialBidDates] = useState(null);
  const [revisedBidDates, setRevisedBidDates] = useState(null);
  const [finalBidDates, setFinalBidDates] = useState(null);

  const currentDate = (() => {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const yyyy = today.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  })();

  const loadStaticData = useCallback(() => {
    setApiLoading(true);
    try {
      const response = STATIC_RFQ_RESPONSE.data;
      const materials = response.bid_rfq_material_wise_detail || [];

      const materialRows = materials.map((m, i) =>
        mapMaterialToTableRow(
          {
            ...m,
            aggregate_conversion: response.aggregate_conversion,
            sand_conversion: response.sand_conversion,
            category_tree_name: response.category_tree_name,
          },
          i
        )
      );

      setTableData([...materialRows, buildGrandTotalRow(materialRows)]);
      setRfqDetails(response);
      setBuyingPatternPayload(response.bid_buying_pattern || response.buying_pattern);
      setRfqData({
        open_order: response.open_order,
        rfqamountcap: response.amount_cap,
        rfqopendeliverydate: response.delivery_date,
        rfqdeliverystartdate: response.delivery_start_date,
        rfqdeliveryenddate: response.delivery_end_date,
        rfqduedate: response.rfq_due_date,
        rfqpricecap: response.price_cap,
      });

      const firstMaterial = materials[0];
      if (firstMaterial) {
        setInitialBidDates(firstMaterial.initial_bid_price_date || null);
        setRevisedBidDates(firstMaterial.revised_bid_price_date || null);
        setFinalBidDates(firstMaterial.final_bid_price_date || null);

        if (firstMaterial.initial_bid_price_date) {
          setCurrentStep(1);
        }
        if (firstMaterial.revised_bid_price_date) {
          setCurrentStep(2);
        }
      }

      const buyingPattern = response.buying_pattern;
      if (buyingPattern === "Unit Rate of Cement excluding Freight") {
        setShowUnitRateOfCement(true);
        setShowUnitRateOfFreight(true);
      } else if (buyingPattern === "Unit Rate of Cement including Freight") {
        setShowUnitRateOfCement(true);
        setShowUnitRateOfFreight(false);
      } else if (buyingPattern === "Total Unit Rate") {
        setShowUnitRateOfCement(false);
        setShowUnitRateOfFreight(true);
      }

    } finally {
      setApiLoading(false);
    }
  }, []);

  useEffect(() => {
    loadStaticData();
  }, [loadStaticData, vendorBidId]);

  const handleInputChange = (e, materialType, fieldName) => {
    const numericValue = parseFloat(e.target.value) || 0;

    setTableData((prevData) => {
      const materialRows = prevData.filter((r) => !r.isGrandTotal);
      const updatedMaterials = materialRows.map((record) => {
        if (record.material_type !== materialType) return record;

        const freightRate =
          fieldName === "initial_bid_price_unit_rate_of_freight" ||
          fieldName === "revised_bid_price_unit_rate_of_freight" ||
          fieldName === "final_bid_price_unit_rate_of_freight"
            ? numericValue
            : fieldName === "initial_bid_price_unit_rate"
            ? record.initial_bid_price_unit_rate_of_freight
            : fieldName === "revised_bid_price_unit_rate"
            ? record.revised_bid_price_unit_rate_of_freight
            : record.final_bid_price_unit_rate_of_freight;

        const unitRate =
          fieldName === "initial_bid_price_unit_rate" ||
          fieldName === "revised_bid_price_unit_rate" ||
          fieldName === "final_bid_price_unit_rate"
            ? numericValue
            : fieldName === "initial_bid_price_unit_rate_of_freight"
            ? record.initial_bid_price_unit_rate
            : fieldName === "revised_bid_price_unit_rate_of_freight"
            ? record.revised_bid_price_unit_rate
            : record.final_bid_price_unit_rate;

        const gstField =
          fieldName === "revised_bid_price_unit_rate" ||
          fieldName === "revised_bid_price_unit_rate_of_freight"
            ? "unit_rate_with_gst_revised"
            : fieldName === "final_bid_price_unit_rate" ||
              fieldName === "final_bid_price_unit_rate_of_freight"
            ? "unit_rate_with_gst_final"
            : "unit_rate_with_gst";

        const amountField =
          fieldName === "revised_bid_price_unit_rate" ||
          fieldName === "revised_bid_price_unit_rate_of_freight"
            ? "revised_bid_price_amount"
            : fieldName === "final_bid_price_unit_rate" ||
              fieldName === "final_bid_price_unit_rate_of_freight"
            ? "final_bid_price_amount"
            : "initial_bid_price_amount";

        const updated = {
          ...record,
          [fieldName]: numericValue,
          [gstField]: calculateUnitRateWithGst(
            unitRate,
            freightRate,
            record.gst_rate,
            record.gst_rate_freight
          ),
          [amountField]: (unitRate + (freightRate || 0)) * record.material_total_quantity,
        };

        return updated;
      });

      return [...updatedMaterials, buildGrandTotalRow(updatedMaterials)];
    });
  };

  const buildPayload = useCallback(
    (rows, bidDates = {}) => {
      const materialRows = rows.filter(
        (entry) => entry.material_type_name && !entry.isGrandTotal
      );

      return {
        vendor: VendorId,
        is_final_bid_price: isFinalBid,
        bid_buying_pattern: buyingPatternPayload,
        bid_rfq_material_wise_detail: materialRows.map((entry) => ({
          rfq_material_detail: entry.rfq_material_detail,
          material_type_name: entry.material_type_name,
          material_type: entry.material_type,
          material_type_sub_category: entry.material_type_sub_category,
          material_total_quantity: entry.material_total_quantity,
          material_total_quantity_by_kg: entry.material_total_quantity_by_kg,
          material_wise_uom: entry.material_wise_uom || "MT",
          unit_of_measurement: entry.material_wise_uom_id || 32,
          gst_rate: entry.gst_rate,
          gst_rate_freight: entry.gst_rate_freight,
          id: entry.bid_rfq_id || null,
          initial_bid_price_unit_rate: entry.initial_bid_price_unit_rate,
          initial_bid_price_unit_rate_of_freight:
            entry.initial_bid_price_unit_rate_of_freight,
          revised_bid_price_unit_rate: entry.revised_bid_price_unit_rate,
          revised_bid_price_unit_rate_of_freight:
            entry.revised_bid_price_unit_rate_of_freight,
          final_bid_price_unit_rate: entry.final_bid_price_unit_rate,
          final_bid_price_unit_rate_of_freight:
            entry.final_bid_price_unit_rate_of_freight,
          initial_bid_amount_with_gst: entry.unit_rate_with_gst || 0,
          initial_bid_amount_without_gst:
            (entry.initial_bid_price_unit_rate || 0) *
              (entry.material_total_quantity || 0) +
            (entry.initial_bid_price_unit_rate_of_freight || 0) *
              (entry.material_total_quantity || 0),
          revised_bid_amount_with_gst: entry.unit_rate_with_gst_revised || 0,
          revised_bid_amount_without_gst: entry.revised_bid_price_amount || 0,
          final_bid_amount_with_gst: entry.unit_rate_with_gst_final || 0,
          final_bid_amount_without_gst: entry.final_bid_price_amount || 0,
          unit_rate_with_gst: entry.unit_rate_with_gst || 0,
          revised_unit_rate_with_gst: entry.unit_rate_with_gst_revised || 0,
          final_unit_rate_with_gst: entry.unit_rate_with_gst_final || 0,
          initial_bid_price_date:
            bidDates.initial || entry.initial_bid_price_date || currentDate,
          revised_bid_price_date:
            bidDates.revised || entry.revised_bid_price_date || currentDate,
          final_bid_price_date:
            bidDates.final || entry.final_bid_price_date || currentDate,
          is_initial_bid: entry.is_initial_bid ?? true,
          is_revised_bid:
            entry.is_initial_bid === true ? true : entry.is_revised_bid,
          is_final_bid:
            entry.is_revised_bid === true ? true : entry.is_final_bid,
        })),
      };
    },
    [VendorId, isFinalBid, buyingPatternPayload, currentDate]
  );

  const handleSubmit = async () => {
    const dateField =
      currentStep === 0
        ? "initial_bid_price_date"
        : currentStep === 1
        ? "revised_bid_price_date"
        : "final_bid_price_date";

    const updatedTableData = tableData.map((item) => {
      if (!item.isGrandTotal && item.material_type_name) {
        return { ...item, [dateField]: currentDate };
      }
      return item;
    });

    setTableData(updatedTableData);

    const payload = buildPayload(updatedTableData, {
      initial: currentStep === 0 ? currentDate : undefined,
      revised: currentStep === 1 ? currentDate : undefined,
      final: currentStep === 2 ? currentDate : undefined,
    });

    try {
      setLoading(true);
      // Static mode: log payload; wire patchRequest when API is ready
      // await patchRequest(`bid-rfq/${vendorBidId}/`, payload);
      console.log("General RFQ material-wise bid payload:", payload);

      setLoading(false);
      setCurrentStep((s) => s + 1);

      if (currentStep === 0) {
        setInitialBidDates(currentDate);
        SuccessNotificationMsg(t("bidding_of_R0"));
      } else if (currentStep === 1) {
        setRevisedBidDates(currentDate);
        if (isFinalBid) {
          SuccessNotificationMsg(t("Final BID Submitted"));
        } else {
          SuccessNotificationMsg(t("bidding_of_R1"));
        }
        navigate("/rfq-vendor-general-request-for-quotation/history/1");
      } else {
        navigate("/rfq-vendor-general-request-for-quotation/history/1");
        SuccessNotificationMsg(
          isFinalBid ? t("Final BID Submitted") : t("bidding_of_R")
        );
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const handleBidSubmission = () => {
    confirmAlert({
      title: "Confirm",
      message: isFinalBid
        ? "Are you sure that you want to submit final no regret price as you will not able to modify the BID subsequently?"
        : "Are you sure you want to Submit BID ?",
      buttons: [
        {
          label: "Yes",
          width: "90px",
          style: {
            backgroundColor: "#094e8f",
            color: "#fff",
            borderRadius: "4px",
            fontSize: "16px",
          },
          onClick: () => handleSubmit(),
        },
        {
          label: "No",
          width: "90px",
          style: {
            backgroundColor: "#d9d9d9",
            color: "#000",
            borderRadius: "4px",
            fontSize: "16px",
          },
        },
      ],
    });
  };

  const isSubmitDisabled = tableData
    .filter((i) => !i.isGrandTotal)
    .every((item) =>
      finalBidDates
        ? item.final_bid_price_unit_rate === 0
        : revisedBidDates
        ? item.revised_bid_price_unit_rate === 0
        : item.initial_bid_price_unit_rate === 0
    );

  const renderBidInputs = (record, fieldUnit, stepRequired, disabled) => {
    if (record.isGrandTotal) {
      const totalKey =
        fieldUnit === "initial_bid_price_unit_rate"
          ? "total_initial_bid_price_unit_rate"
          : fieldUnit === "revised_bid_price_unit_rate"
          ? "total_revised_bid_price_unit_rate"
          : "total_final_bid_price_unit_rate";
      return (
        <div className="subtotal1" style={{ marginLeft: "1px" }}>
          ₹ {record[totalKey]?.toLocaleString("en-IN") ?? "0"}
        </div>
      );
    }

    if (currentStep !== stepRequired) {
      return (
        <div style={{ marginLeft: "1px", marginTop: "3px" }}>
          ₹ {record[fieldUnit] ?? ""}
        </div>
      );
    }

    return (
      <Input
        value={record[fieldUnit] ?? ""}
        prefix={<RupeesSign />}
        maxLength={5}
        disabled={disabled}
        onChange={(e) => handleInputChange(e, record.material_type, fieldUnit)}
        style={{ width: "80px" }}
      />
    );
  };

  const getColumns = () => {
    const columns = [
      {
        title: "Sr.",
        dataIndex: "sr_no",
        key: "sr_no",
        width: 50,
        fixed: "left",
        render: (text, record) => (record.isGrandTotal ? null : text),
      },
      {
        title: "Sub category",
        dataIndex: "material_type_sub_category",
        key: "material_type_sub_category",
        width: 140,
        fixed: "left",
        render: (text, record) =>
          record.isGrandTotal ? (
            <div className="subtotal1" style={{ textAlign: "center" }}>
              {record.rowLabel}
            </div>
          ) : (
            text
          ),
      },
      {
        title: "Material Type",
        dataIndex: "material_type_name",
        key: "material_type_name",
        width: 130,
        fixed: "left",
        render: (text, record) => (record.isGrandTotal ? null : text),
      },
      {
        title: "Qty.",
        dataIndex: "material_total_quantity",
        key: "material_total_quantity",
        align: "right",
        width: 60,
        fixed: "left",
        render: (text, record) =>
          record.isGrandTotal
            ? null
            : (
              <div style={{ marginRight: "10px" }}>
                {Number(record.material_total_quantity).toFixed(2)}
              </div>
            ),
      },
      {
        title: "UoM.",
        dataIndex: "material_wise_uom",
        key: "material_wise_uom",
        width: 100,
        fixed: "left",
        render: (text) => (text === "Cubic Meter" ? "Cu. Mtr." : text),
      },
    ];

    const addBidStage = (stageTitle, tooltipTitle, fields, stepRequired) => {
      columns.push({
        title: (
          <Tooltip color="#094E8F" placement="top" title={tooltipTitle}>
            <span>{stageTitle}</span>
          </Tooltip>
        ),
        children: [
          showUnitRateOfCement && {
            title: "Unit Rate",
            dataIndex: fields.unit,
            key: fields.unit,
            width: 120,
            render: (text, record) =>
              renderBidInputs(
                record,
                fields.unit,
                stepRequired,
                currentStep !== stepRequired
              ),
          },
          showUnitRateOfFreight && {
            title: "Unit Rate Freight",
            dataIndex: fields.freight,
            key: fields.freight,
            width: 110,
            align: "right",
            render: (text, record) => {
              if (record.isGrandTotal) return null;
              if (currentStep !== stepRequired) {
                return (
                  <div style={{ textAlign: "end" }}>
                    ₹ {record[fields.freight] ?? 0}
                  </div>
                );
              }
              return (
                <Input
                  value={record[fields.freight] ?? ""}
                  prefix={<RupeesSign />}
                  maxLength={5}
                  onChange={(e) =>
                    handleInputChange(e, record.material_type, fields.freight)
                  }
                  style={{ width: "80px" }}
                />
              );
            },
          },
          showUnitRateOfCement && {
            title: "Amount",
            dataIndex: fields.amount,
            key: fields.amount,
            width: 130,
            align: "right",
            render: (text, record) => {
              if (record.isGrandTotal) {
                const totalKey =
                  fields.unit === "initial_bid_price_unit_rate"
                    ? "total_initial_bid_price_unit_rate"
                    : fields.unit === "revised_bid_price_unit_rate"
                    ? "total_revised_bid_price_unit_rate"
                    : "total_final_bid_price_unit_rate";
                return (
                  <div className="subtotal1">
                    ₹ {record[totalKey]?.toLocaleString("en-IN") ?? "0"}
                  </div>
                );
              }
              return (
                <div className="normal-field">
                  ₹{" "}
                  {record[fields.amount]?.toLocaleString("en-IN", {
                    maximumFractionDigits: 0,
                  }) ?? "0"}
                </div>
              );
            },
          },
          showUnitRateOfCement && {
            title: "Unit Rate With GST",
            dataIndex: fields.gst,
            key: fields.gst,
            width: 130,
            align: "right",
            render: (text, record) =>
              record.isGrandTotal ? null : (
                <div className="normal-field">
                  ₹ {Number(record[fields.gst] || 0).toFixed(2)}
                </div>
              ),
          },
        ].filter(Boolean),
      });
    };

    if (finalBidDates || currentStep >= 2) {
      addBidStage(
        "R (Without GST)",
        "R - Final BID",
        {
          unit: "final_bid_price_unit_rate",
          freight: "final_bid_price_unit_rate_of_freight",
          amount: "final_bid_price_amount",
          gst: "unit_rate_with_gst_final",
        },
        2
      );
    }

    if ((revisedBidDates || currentStep >= 1) && !hideR1) {
      addBidStage(
        "R1 (Without GST)",
        "R1 - Revised BID",
        {
          unit: "revised_bid_price_unit_rate",
          freight: "revised_bid_price_unit_rate_of_freight",
          amount: "revised_bid_price_amount",
          gst: "unit_rate_with_gst_revised",
        },
        1
      );
    }

    if (!hideR0) {
      addBidStage(
        "R0 (Without GST)",
        "R0 - Initial BID",
        {
          unit: "initial_bid_price_unit_rate",
          freight: "initial_bid_price_unit_rate_of_freight",
          amount: "initial_bid_price_amount",
          gst: "unit_rate_with_gst",
        },
        0
      );
    }

    return columns.filter(Boolean);
  };

  const columns = useMemo(() => getColumns(), [
    tableData,
    currentStep,
    hideR0,
    hideR1,
    initialBidDates,
    revisedBidDates,
    finalBidDates,
    showUnitRateOfCement,
    showUnitRateOfFreight,
  ]);

  const transformedData = {
    companyName: rfqDetails.company,
    rfqnumber: rfqDetails.rfq_number,
    rfqcurrency: rfqDetails.currency_name,
    rfqpricebasis: rfqDetails.price_basis,
    rfqfreight: rfqDetails.freight,
    rfqunloading: rfqDetails.unloading,
    rfqtransportInsurance: rfqDetails.transport_insurance,
    rfqduedate: rfqDetails.rfq_due_date,
    rfqopendeliverydate: rfqDetails.delivery_date,
    rfqamountcap: rfqDetails.amount_cap || "N/A",
    rfqdeliverystartdate: rfqDetails.delivery_start_date || "N/A",
    rfqdeliveryenddate: rfqDetails.delivery_end_date || "N/A",
    open_order: rfqDetails.open_order,
  };

  const columns1 = [
    { title: "Company Name", dataIndex: "companyName", key: "companyName" },
    { title: "RFQ Number", dataIndex: "rfqnumber", key: "rfqnumber" },
    { title: "Currency", dataIndex: "rfqcurrency", key: "rfqcurrency" },
    { title: "Price Basis", dataIndex: "rfqpricebasis", key: "rfqpricebasis" },
    { title: "Freight", dataIndex: "rfqfreight", key: "rfqfreight" },
    {
      title: "Transport Insurance",
      dataIndex: "rfqtransportInsurance",
      key: "rfqtransportInsurance",
    },
    { title: "Unloading", dataIndex: "rfqunloading", key: "rfqunloading" },
    { title: "RFQ Due Date", dataIndex: "rfqduedate", key: "rfqduedate" },
    !rfqData.open_order && {
      title: "Delivery Date",
      dataIndex: "rfqopendeliverydate",
      key: "rfqopendeliverydate",
      render: (text, record) =>
        record.open_order ? "N/A" : record.rfqopendeliverydate,
    },
    rfqData.open_order && {
      title: "Amount Cap",
      dataIndex: "rfqamountcap",
      key: "rfqamountcap",
      render: (text, record) => (record.open_order ? text : "N/A"),
    },
    rfqData.open_order && {
      title: "Delivery Start Date",
      dataIndex: "rfqdeliverystartdate",
      key: "rfqdeliverystartdate",
      render: (text, record) => (record.open_order ? text : "N/A"),
    },
    rfqData.open_order && {
      title: "Delivery End Date",
      dataIndex: "rfqdeliveryenddate",
      key: "rfqdeliveryenddate",
      render: (text, record) => (record.open_order ? text : "N/A"),
    },
  ].filter(Boolean);

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename" style={{ whiteSpace: "nowrap" }}>
            <h3>BID RFQ - Vendor (General)</h3>
            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/rfq-vendor-general-request-for-quotation/history/1">
                  {t("RFQ History - Vendor")}
                </Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>BID RFQ - Vendor</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <ButtonField
            type="primary"
            className="CancelGradiantBtn"
            htmlType="button"
            label={t("Back")}
            onClick={() =>
              navigate("/rfq-vendor-general-request-for-quotation/history/1")
            }
          />
        </div>
      </div>

      <div className="stepscontentwrap">
        <div className="stepsContent">
          <section className="grid-sec ">
            <div className="PR-body" style={{ padding: "0" }}>
              <Collapse
                defaultActiveKey={[0]}
                className="custom-collapse-table"
              >
                <Panel header="RFQ Details" key={0}>
                  <div style={{ marginTop: "10px" }}>
                    <Table
                      className="custom-head"
                      columns={columns1}
                      dataSource={[transformedData]}
                      pagination={false}
                    />
                  </div>
                </Panel>
              </Collapse>

              <Form autoComplete="off" ref={formRef}>
                <Spin spinning={apiLoading}>
                  <Table
                    columns={columns}
                    dataSource={tableData}
                    pagination={false}
                    bordered
                    scroll={{ x: 1000 }}
                    sticky
                  />
                </Spin>

                <div className="FormFooter">
                  {currentStep !== 2 && (
                    <Checkbox
                      checked={isFinalBid}
                      onChange={(e) => setIsFinalBid(e.target.checked)}
                    >
                      <span className="finalBid">
                        Is This Your Final Bid Price?
                      </span>
                    </Checkbox>
                  )}
                  {currentStep >= 1 && (
                    <Checkbox
                      checked={hideR0}
                      onChange={(e) => setHideR0(e.target.checked)}
                    >
                      Hide Initial BID Price - R0
                    </Checkbox>
                  )}
                  {currentStep >= 2 && (
                    <Checkbox
                      checked={hideR1}
                      onChange={(e) => setHideR1(e.target.checked)}
                    >
                      Hide BID Price - R1
                    </Checkbox>
                  )}
                </div>
              </Form>
            </div>
          </section>
        </div>

        <div
          className="FormFooter bidftr"
          style={{ padding: "16px", margin: "0" }}
        >
          <ButtonField
            type="primary"
            className="CancelGradiantBtn"
            htmlType="button"
            label={t("Back")}
            onClick={() =>
              navigate("/rfq-vendor-general-request-for-quotation/history/1")
            }
          />
          <ButtonField
            type="primary"
            className="SaveGradiantBtn"
            htmlType="button"
            label="Submit BID"
            onClick={handleBidSubmission}
            loading={loading}
            disabled={isSubmitDisabled}
          />
        </div>
      </div>
    </>
  );
};

export default VendorBidGeneralRFQ;
